<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true }" class="subnav__exists promo-code-edit">
    <ng-container *ngIf="promoCode">
      <div fxLayout="column" fxLayoutGap="24px" class="relative">
        <app-feature-flag-tabs>
          <sbnb-page-header
            navTabs
            class="!mb-0 block sbnbDesktop:hidden absolute top-0 left-0 right-0"></sbnb-page-header>
        </app-feature-flag-tabs>
        <sbnb-content-header
          title="Edit promo code"
          backLink="/direct/promotions"
          novaContentId="direct-promo-codes-edit"
          [saving]="saving"
          [recentlySaved]="recentlySaved"
          (saveClicked)="saveCode()"></sbnb-content-header>

        <sbnb-promo-codes-edit-codes
          [hideHeader]="true"
          [promoCode]="promoCode"
          [shouldFocus]="false"
          [currencies]="currencies$ | async"
          (currencyChanged)="checkForPropertyRestrictions(promoCode)"
          (promoCodeTypeChanged)="checkForPropertyRestrictions(promoCode)"></sbnb-promo-codes-edit-codes>

        <sbnb-promo-codes-edit-restrictions [promoCode]="promoCode"></sbnb-promo-codes-edit-restrictions>

        <h2>Applicable Properties</h2>

        <sbnb-property-selection
          [border]="true"
          [listHeight]="280"
          [selectedProperties]="promoCode.properties"
          [disabledProperties]="overlappingProperties"
          (propertiesChange)="onPropertiesChange($event.properties)"></sbnb-property-selection>
      </div>
    </ng-container>
  </main>
</div>
